import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { clearOwnerError, resetOwnerPassword } from '@main/features/auth/ownerAuthSlice';
import { UiButton, UiInput, UiLinkButton } from '@shared/common/ui';

export function ResetPasswordPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const error = useSelector((s) => s.ownerAuth.error);
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token')?.trim() ?? '', [searchParams]);
  const [doneMessage, setDoneMessage] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { password: '', passwordRepeat: '' } });

  useEffect(() => () => dispatch(clearOwnerError()), [dispatch]);

  if (!token) {
    return (
      <div className="auth-card">
        <h1>Сброс пароля</h1>
        <p className="form-error">В ссылке нет ключа. Запросите восстановление пароля ещё раз.</p>
        <UiLinkButton to="/" variant="link">
          На страницу входа
        </UiLinkButton>
      </div>
    );
  }

  const onSubmit = async (values) => {
    const result = await dispatch(resetOwnerPassword({ token, password: values.password }));
    if (resetOwnerPassword.fulfilled.match(result)) {
      setDoneMessage(result.payload);
      setTimeout(() => navigate('/'), 2000);
    }
  };

  return (
    <div className="auth-card">
      <h1>Новый пароль</h1>
      {doneMessage ? (
        <div className="banner banner--info">{doneMessage}</div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <UiInput
            label="Пароль"
            type="password"
            autoComplete="new-password"
            error={errors.password?.message}
            {...register('password', {
              required: 'Введите пароль',
              minLength: { value: 6, message: 'Не меньше 6 символов' },
            })}
          />
          <UiInput
            label="Повтор пароля"
            type="password"
            autoComplete="new-password"
            error={errors.passwordRepeat?.message}
            {...register('passwordRepeat', {
              required: 'Повторите пароль',
              validate: (v, form) => (v === form.password ? true : 'Пароли не совпадают'),
            })}
          />
          {error && <span className="form-error">{error}</span>}
          <UiButton type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Сохраняем…' : 'Сохранить пароль'}
          </UiButton>
        </form>
      )}
      <div style={{ marginTop: 16 }}>
        <UiLinkButton to="/" variant="link">
          На страницу входа
        </UiLinkButton>
      </div>
    </div>
  );
}
